// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"690":"df04f97c808c0be6","888":"23a55081886c94f0"}[chunkId] + ".css";
};